<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import ListDefault from './ListDefault'
import ListOld from './ListOld'
const ListSchlum = () => import('@/process/schlumberger-career/components/responses/ListSchlum')
const ListSportmaster = () => import('@/process/sportmaster/components/responses/ListSportmaster')
const ListCitibank = () => import('@/process/citibank/components/responses/ListCitibank')
import PROCESS_NAMES from "@/process/names"

export default {
  name: "responses-list-process",

  components: {
    ListDefault,
    ListOld,
    ListSchlum,
    ListSportmaster,
    ListCitibank
  },
  computed: {
    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.getProcessName !== undefined) {
        if (
          this.getProcessName === PROCESS_NAMES.CITIBANK ||
          this.getProcessName === PROCESS_NAMES.CITIBANK_RYAZAN ||
          this.getProcessName === PROCESS_NAMES.CITIBANK_AMBASSADOR
        ) {
          return 'list-citibank'
        } else if (this.getProcessName === PROCESS_NAMES.SPORTMASTER) {
          return 'list-sportmaster'
        } else if (
          this.getProcessName === PROCESS_NAMES.SCHLUMBERGER ||
          this.getProcessName === PROCESS_NAMES.SCHLUMBERGER_CAREER_TEST ||
          this.getProcessName === PROCESS_NAMES.SCHLUMBERGER_CAREER
        ) {
          return 'list-schlum'
        }

        return `list-default`
      }

      return `list-default`
    }
  }
};
</script>
